module.exports = "/_next/static/images/91a424076430a818c59354d848a53d98-woman-playing-with-her-kids@xl.jpg";